<template>
  <header>
    <div class="columns is-mobile is-tablet is-desktop is-multiline">
      <div class="column is-3-mobile is-2-tablet is-1-desktop order-2">
        <button class="button navbar-burger" :class="{ 'is-active': isOpen }" @click="toggle">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div class="column is-12-mobile is-4-tablet is-5-desktop order-1 border-responsive">
        <div class="logo">
          <router-link :to="{ name: isLoggedIn ? 'DashboardView' : 'WelcomeView'}">
            <img src="../../../assets/images/KIWA-logo.png" alt="KIWA">
          </router-link>
        </div>
      </div>
      <div class="column is-9-mobile is-6-tablet is-6-desktop order-3">
        <div class="auth-section">
          <action-dropdown-component :actions="actions" class="main-action-bar">
            <hr class="dropdown-divider">
            <div class="dropdown-item language-select">
              <button class="button is-link is-radiusless" :class="isLangActive('en')" @click="changeLanguage('en')">
                EN
              </button>
              <button class="button is-link is-radiusless" :class="isLangActive('sv')" @click="changeLanguage('sv')">
                SV
              </button>
            </div>
          </action-dropdown-component>
          <span v-if="isLoggedIn" class="sign-as-item">
              <span class="is-hidden-mobile" v-if="authUser.fullName" v-translate>Signed in as</span>
              <span>&nbsp;{{ authUser.fullName }}&nbsp;</span>
              <span class="tag is-success label-switched" v-if="isSwitchedWithConnectedProfile"
                    v-translate>{{ authUser.profile.profileTypeDisplay }}</span>
              <span class="tag is-info label-switched" v-else-if="isSwitchedProfile" v-translate>switched</span>
            </span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import ActionDropdownComponent from '@/components/layout/utility/ActionDropdownComponent'
  import AuthUser from '@/classes/auth/AuthUser'
  import { errorHandler } from '@/mixins/mixins'

  export default {
    name: 'navbar-component',
    mixins: [errorHandler],
    components: {
      ActionDropdownComponent
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        actions: []
      }
    },
    computed: {
      ...mapState({
        authUser: state => state.authModule.authUser,
        isLoggedIn: state => state.authModule.isLoggedIn
      }),
      isSwitchedProfile () {
        return this.authUser && this.authUser.isSwitchedProfile()
      },
      isSwitchedWithConnectedProfile () {
        return this.authUser && this.authUser.isSwitchedWithConnectedProfile()
      },
      profiles () {
        return (this.authUser &&
          this.authUser.profiles &&
          this.authUser.profiles.filter(profile => profile.profileType !== this.authUser.profile.profileType)) || []
      }
    },
    methods: {
      ...mapActions([
        'logoutUser',
        'resetProfile',
        'switchProfile'
      ]),
      getPathForCustomerPath () {
        let path = this.$route.path
        if (path === '/profile') {
          return `/customers/${this.authUser.profile.id}`
        }
        return path
      },
      isLangActive (lang) {
        return {
          'is-lang-active': this.$language.current === lang
        }
      },
      toggle () {
        this.$emit('toggle', !this.isOpen)
      },
      switchBackTo (path) {
        this.resetProfile(path).catch((err) => {
          this.handleError(err)
        })
      },
      changeLanguage (lang) {
        this.$language.current = lang
        AuthUser.setLanguage(lang)
        this.$root.$emit('languageChanged')
      },
      logout () {
        this.logoutUser().then(() => {
          this.setActions()
        }).catch((err) => {
          this.handleError(err)
        })
      },
      setActions () {
        this.actions = []
        // add users profiles
        if (this.isLoggedIn) {
          for (let profile of this.profiles) {
            this.actions.push({
              type: 'ACTION',
              func: () => {
                if (AuthUser.isMainProfile(profile)) {
                  this.switchBackTo(this.getPathForCustomerPath())
                } else {
                  let routeData = {
                    userId: profile.userId,
                    profileType: this.authUser.profile.getSwitchType(),
                    path: this.$route.path
                  }
                  if (AuthUser.isLoggedIn()) {
                    this.switchProfile(routeData).catch((err) => {
                      this.handleError(err)
                    })
                  } else {
                    this.logout()
                  }
                }
              },
              text: profile.profileTypeDisplay
            })
          }
        }
        // add login or logout link
        if (!this.isLoggedIn) {
          this.actions.push({
            type: 'ROUTE',
            route: { name: 'LoginView' },
            text: 'Login'
          })
        } else {
          this.actions.push({
            type: 'ACTION',
            func: () => {
              this.logout()
            },
            text: 'Logout'
          })
        }
      }
    },
    created () {
      this.setActions()
    }
  }
</script>

<style lang="sass" scoped>
@import src/assets/sass/kiwa-styles

.no-public
  margin-top: 1.1rem
  margin-right: 1em
  vertical-align: middle
  text-align: right

span
  display: inline-block
  vertical-align: middle

header
  position: relative
  min-height: 4.616rem
  background-color: white
  border-bottom: 1px solid #c3cdc8
  box-shadow: 0 2px 5px rgba(10, 10, 10, 0.1)
  -webkit-box-shadow: 0 2px 5px rgba(10, 10, 10, 0.1)

  .navbar-burger
    display: inline-block
    width: 4.616rem
    height: 4.616rem
    border: none
    border-radius: 0
    background: $kiwa-secondary-dark

    span
      width: 16px
      background-color: #fff

    @media screen and (min-width: 1008px)
      display: inline-block

  .logo
    max-width: 116px
    margin: 0.538em auto 0.4em
    float: none
    @media screen and (min-width: 769px)
      float: right
      margin: 0.738em 0 0.4em

  .border-responsive
    border-bottom: none
    @media screen and (max-width: 769px)
      border-bottom: 1px solid #e0e0e0

  .auth-section
    height: 100%
    vertical-align: middle

    .sign-as-item
      float: right
      height: 100%
      padding-top: 1.43rem
      padding-right: 0.7rem
      vertical-align: middle

    .action-bar
      width: 4.616rem
      height: 4.616rem
      padding-top: 1.2rem
      float: right

.language-select:hover
  background-color: #fff

.language-select
  text-align: center
  cursor: default

  button
    margin-left: 0.3rem
    margin-right: 0.3rem

.is-lang-active
  border: 1px solid $kiwa-accent-dark !important

.is-link
  background-color: $kiwa-accent !important
</style>
